import { useEffect, useState } from "react";
import { Input, trim } from "../../../../../components";
import { EditorInput } from "../../../../../components/input/EditorInput";

interface Props {
  title: string;
  name?: string;
  startDate?: string;
  endDate?: string;
  isEditable: boolean;
  onHeaderContentUpdate?: (title: string) => void;
  onWorkplaceNameClick: () => void;
}

export const ProjectHeader = ({
  title,
  name,
  startDate,
  endDate,
  isEditable,
  onHeaderContentUpdate,
  onWorkplaceNameClick,
}: Props) => {
  const [localTitle, setLocalTitle] = useState(title ?? "");
  return (
    <div className="flex flex-col">
      {isEditable ? (
        <EditorInput
          label="Project title"
          transformValue={trim}
          value={localTitle}
          onBlur={(
            event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => {
            const inputValue = event.target.value;
            setLocalTitle(inputValue);
            if (onHeaderContentUpdate) {
              onHeaderContentUpdate(inputValue);
            }
          }}
          onChange={(
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => {
            setLocalTitle(event.target.value);
          }}
        />
      ) : (
        <p className="font-semibold">{title}</p>
      )}

      <div className="flex flex-row justify-between">
        {isEditable ? (
          <EditorInput
            label="Select workplace"
            transformValue={trim}
            value={name}
            onClick={() => onWorkplaceNameClick()}
            onBlur={(
              event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
            ) => {}}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
            ) => {}}
            className="text-gray-6 text-sm"
          />
        ) : (
          name && <p className="text-gray-6 text-sm font-medium">{name}</p>
        )}

        {startDate && (
          <p className="text-gray-6">
            {endDate ? `${startDate} - ${endDate}` : `${startDate} - current`}
          </p>
        )}
      </div>
    </div>
  );
};
